import { Injectable } from '@angular/core';
import { AppConfig } from '../app.config';

@Injectable()
export class EntraLoginManager {
  constructor(private config: AppConfig) {
  }

  getClientId(): string {
    return this.config.getConfig('clientId');
  }

  getEntraLoginEndpoint(): string {
    return this.config.getConfig('entraLoginEndpoint');
  }

  getEntraTokenEndpoint(): string {
    return this.config.getConfig('entraTokenEndpoint');
  }

  getEntraScope(): string {
    return this.config.getConfig('entraScope');
  }

  getEntraRedirectUri(language: string): string {
    return this.config.getConfig('entraRedirectUri') || location.origin;
  }

  getPostLoginRedirectUrl(returnUrl: string, language: string): string {
    if (returnUrl &&
      returnUrl !== '/' &&
      returnUrl !== `/${language}/login` &&
      returnUrl.indexOf('code=') === -1 &&
      returnUrl.indexOf('state=') === -1 &&
      returnUrl.indexOf('?') === -1) {
      return returnUrl;
    }

    return `/${language}/maintenancetasks`;
  }

  buildAuthorizationUrl(loginEndpoint: string, clientId: string, redirectUri: string, scope: string, state: string, codeChallenge: string): string {
    return `${loginEndpoint}?` +
      `client_id=${encodeURIComponent(clientId)}&` +
      `response_type=code&` +
      `redirect_uri=${encodeURIComponent(redirectUri)}&` +
      `response_mode=query&` +
      `scope=${encodeURIComponent(scope)}&` +
      `state=${encodeURIComponent(state)}&` +
      `code_challenge=${encodeURIComponent(codeChallenge)}&` +
      `code_challenge_method=S256&` +
      `prompt=select_account`;
  }

  resetLoginUrl(language: string): void {
    window.history.replaceState({}, '', location.origin + `/${language}/login`);
  }

  getCodeVerifier(state: string): string {
    return sessionStorage.getItem('pkce_' + state);
  }

  clearCodeVerifier(state: string): void {
    sessionStorage.removeItem('pkce_' + state);
  }

  saveCodeVerifier(state: string, codeVerifier: string): void {
    sessionStorage.setItem('pkce_' + state, codeVerifier);
  }

  async createCodeChallenge(codeVerifier: string): Promise<string> {
    const textEncoder = (window as any).TextEncoder ? new (window as any).TextEncoder() : null;
    const data = textEncoder ? textEncoder.encode(codeVerifier) : codeVerifier;
    const digest = await (window as any).crypto.subtle.digest('SHA-256', data);
    return this.base64UrlEncode(digest);
  }

  private base64UrlEncode(buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer);
    let binary = '';
    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }

    return btoa(binary)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/g, '');
  }

  randomString(length: number, chars: string): string {
    let result = '';
    for (let i = length; i > 0; --i) {
      result += chars[Math.floor(Math.random() * chars.length)];
    }
    return result;
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/managers/entra-login.manager.ts